import React from "react";
import ConteudoEsquerda from "./AuthCommon/ConteudoEsquerda";
import FormWrapper from "./AuthCommon/FormWrapper";
import CommonSelect from "../../components/forms/CommonSelect";
import { AppContext } from "../../contexts/AppContext";
import useApi from "../../hooks/useApi";
import AuthApiClient from "../../api/auth";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";

function Empresas() {
  const [empresas, setEmpresas] = React.useState([]);
  const [values, setValues] = React.useState({});
  const { baseUrl, session } = React.useContext(AppContext);

  const logarEmpresaApi = useApi(AuthApiClient.logarEmpresa);

  const trataEmpresas = React.useCallback((empresasTratar) => {
    const empresasData = [];
    Object.keys(empresasTratar).forEach((contabilidade) => {
      const optgroup = {
        text: contabilidade,
        children: [],
      };
      empresasTratar[contabilidade].forEach((empresa) => {
        optgroup.children.push({
          value: empresa?.cnpj ? empresa?.cnpj : "-",
          "data-contabilidade": contabilidade,
          "data-uidempresa": empresa?.uid,
          text: empresa?.pCnpj
            ? `${empresa?.razao_social} (${empresa?.pCnpj})`
            : empresa?.razao_social,
        });
      });
      empresasData.push(optgroup);
    });
    return empresasData;
  }, []);

  //Pega empresas do armazenamento local
  React.useEffect(() => {
    var empresasStorage = localStorage.getItem("empresas");
    if (!empresasStorage) return (window.location.href = `${baseUrl}logout`);
    empresasStorage = JSON.parse(empresasStorage);
    const empresasTratadas = trataEmpresas(empresasStorage.empresas);
    setEmpresas(empresasTratadas);
  }, [baseUrl, trataEmpresas]);

  //Faz logout caso haja dados armazenados na sessão
  React.useEffect(() => {
    if (session && Object.keys(session).length !== 0)
      window.location.href = `${baseUrl}logout`;
  }, [baseUrl, session]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("empresa", values?.empresa);
    formData.append("uid_empresa", values?.uid_empresa);
    formData.append("contabilidade", values?.contabilidade);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor selecionar uma empresa.",
      });

    const response = await logarEmpresaApi.request(formData);
    if (!response) return;
    localStorage.clear("empresas");
    if (response?.congelada === "true")
      return (window.location.href = baseUrl + "congelada/Congelada");
    window.location.href = baseUrl + response?.url;
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <ConteudoEsquerda />
          <FormWrapper>
            <div>
              <h5 className="first-text">Escolha uma empresa para acessar</h5>
            </div>
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <CommonSelect
                    label="Empresa (CNPJ)"
                    labelStyle={{
                      fontSize: "15px",
                      fontWeight: "lighter",
                      marginBottom: "0px",
                    }}
                    id="empresa"
                    value={values.empresa}
                    onChange={(e) => {
                      const selectedOption =
                        e.target.options[e.target.selectedIndex];
                      const selectedContabilidade = selectedOption
                        ? selectedOption?.dataset?.contabilidade
                        : null;
                      const selectedEmpresaUid = selectedOption
                        ? selectedOption?.dataset?.uidempresa
                        : null;

                      setValues({
                        ...values,
                        [e.target.name]: e.target.value,
                        contabilidade: selectedContabilidade,
                        uid_empresa: selectedEmpresaUid,
                      });
                    }}
                    data={empresas}
                    placeholder="Selecione"
                    required
                  />
                </div>
                <div className="mt-3 d-grid">
                  <button
                    className="btn btn-primary waves-effect waves-light auth-button"
                    type="submit"
                  >
                    Selecione
                  </button>
                </div>
                <div className="mt-3 mb-3 d-grid">
                  <button
                    id="sairSistemaEmpresas"
                    className="btn btn-primary waves-effect waves-light auth-button-red"
                    type="button"
                    onClick={() => {
                      window.location.href = `${baseUrl}logout`;
                    }}
                  >
                    Sair
                  </button>
                </div>
              </form>
            </div>
          </FormWrapper>
        </div>
      </div>
    </>
  );
}

export default Empresas;
